// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.most_tickers_component{
    width: 100%;
  }
  
  .most_tickers_header{
    display: flex;
    width: 100%;
    padding: 10px 0px;
    justify-content: space-between;
    align-items: center;
  }
  
  .most_tickers_header h3{
    margin: 0;
  }
  
  /* StockTable.css */
  .stock-table {
      width: 100%;
  }
  
  .stock-table hr {
      width: 100%;
  }
  
  .stock-table th,
    .stock-table td {
        padding: 8px;
        text-align: center;
    }
    
    .stock-icon {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    
    .stock-icon img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
    
    .stock-gauge {
      display: flex;
      align-items: center;
      height: 10px;
      width: 70%;
      background-color: #eee;
      box-sizing: border-box;
      border-radius: 20px;
      overflow: hidden;
    }
    
    .stock-gauge-fill {
      background-color: #4caf50;
      color: white;
      display: flex;
      align-items: center;
      height: 10px;
      justify-content: flex-end;
    }
    
    .stock-gauge-fill-negative {
      background-color: #f44336;
      color: white;
      display: flex;
      align-items: center;
      height: 10px;
      justify-content: flex-start;
    }
    
    .stock-gauge-fill span {
      padding: 0 5px;
      font-weight: bold;
    }
    
    .stock_detail_trade{
      display: flex;
      align-items: center;
      gap: 10px;
    }
  
    .stock-trades-info-number{
      width: 15%;
    }`, "",{"version":3,"sources":["webpack://./src/pages/actifs/subpages/Tickers/TickerMostTrade/TickerMostTrade.css"],"names":[],"mappings":"AAAA;IACI,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA,mBAAmB;EACnB;MACI,WAAW;EACf;;EAEA;MACI,WAAW;EACf;;EAEA;;QAEM,YAAY;QACZ,kBAAkB;IACtB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,UAAU;MACV,sBAAsB;MACtB,sBAAsB;MACtB,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,yBAAyB;MACzB,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;MACzB,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,2BAA2B;IAC7B;;IAEA;MACE,cAAc;MACd,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;;IAEA;MACE,UAAU;IACZ","sourcesContent":[".most_tickers_component{\n    width: 100%;\n  }\n  \n  .most_tickers_header{\n    display: flex;\n    width: 100%;\n    padding: 10px 0px;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .most_tickers_header h3{\n    margin: 0;\n  }\n  \n  /* StockTable.css */\n  .stock-table {\n      width: 100%;\n  }\n  \n  .stock-table hr {\n      width: 100%;\n  }\n  \n  .stock-table th,\n    .stock-table td {\n        padding: 8px;\n        text-align: center;\n    }\n    \n    .stock-icon {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n    \n    .stock-icon img {\n      width: 30px;\n      height: 30px;\n      border-radius: 50%;\n    }\n    \n    .stock-gauge {\n      display: flex;\n      align-items: center;\n      height: 10px;\n      width: 70%;\n      background-color: #eee;\n      box-sizing: border-box;\n      border-radius: 20px;\n      overflow: hidden;\n    }\n    \n    .stock-gauge-fill {\n      background-color: #4caf50;\n      color: white;\n      display: flex;\n      align-items: center;\n      height: 10px;\n      justify-content: flex-end;\n    }\n    \n    .stock-gauge-fill-negative {\n      background-color: #f44336;\n      color: white;\n      display: flex;\n      align-items: center;\n      height: 10px;\n      justify-content: flex-start;\n    }\n    \n    .stock-gauge-fill span {\n      padding: 0 5px;\n      font-weight: bold;\n    }\n    \n    .stock_detail_trade{\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n  \n    .stock-trades-info-number{\n      width: 15%;\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
